/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetProductRequest
 */
export interface GetProductRequest {
    /**
     * 
     * @type {string}
     * @memberof GetProductRequest
     */
    productId: string;
}

export function GetProductRequestFromJSON(json: any): GetProductRequest {
    return GetProductRequestFromJSONTyped(json, false);
}

export function GetProductRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProductRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productId': json['product_id'],
    };
}

export function GetProductRequestToJSON(value?: GetProductRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_id': value.productId,
    };
}


